export enum PayrollTypeEnum {
    SalariedForm = "Salaried Form",
    LabourForm = "Labour Form",
}

export enum PayrollTypeNormalEnum {
    Normal = "Normal"
}